import { tt, type HubTab } from '@agos/shared'

/**
 * *Externé Firmy*, as tabs - FRONTEND.md §9.347, the owner's C2.
 *
 * The owner quoted `SuppliersPage`'s own subtitle - *"Firmy, od ktorých kuchyňa nakupuje, a ich kódy
 * na faktúrach"* - and asked for it to become *Externé Firmy* with *Dodávatelia* and *Firmy* under
 * it. Two kinds of company: who the kitchen buys from, and who the restaurant invoices.
 *
 * **Each tab keeps the gate its own route carries**, which is §9.302's invariant for a fold: a tab
 * shows to exactly whoever could reach that route. `suppliers` and `invoices.outgoing` are separate
 * modules as well as separate permissions, so a franchise on a tier with one and not the other sees
 * one tab - and the hub route gates on `anyPermission` of the two rather than on either, because a
 * hub gated on one would refuse somebody who holds only the other (FB-001's shape).
 *
 * **Not `firmy` as a permission.** The Firmy list exists to fill an outgoing invoice, so it is gated
 * on the invoice's own key - one tier decision covers the document and the list behind its dropdown.
 */
export const EXTERNAL_COMPANY_TABS: readonly HubTab[] = [
  {
    // First because it is what somebody opening this section has always come for.
    id: 'suppliers',
    label: tt('Dodávatelia'),
    path: '/suppliers',
    guard: { permission: 'suppliers', franchiseModule: 'suppliers' },
  },
  {
    id: 'companies',
    label: tt('Firmy'),
    path: '/invoice-companies',
    guard: { permission: 'outgoing_invoices', franchiseModule: 'invoices.outgoing' },
  },
]
